export default __webpack_public_path__ + "static/media/edit.f4969177.svg";